
export class PericiaDTO{
    dtRealizacao: string  = void(0);
	dtAlteracao: string = void(0);
	cdDocumento: number = void(0);
	nmSolicitante: string = void(0);
	nrDocumento: string = void(0);
	txtObservacao: string = void(0);
	dtValidade: string = void(0);
	lgAcompanhante: number = void(0);
	nmSituacaoDocumento: string = void(0);
	nmMedico: string = void(0);
	cdSituacaoDocumento: number = void(0);
}

export class PericiaListDTO {
    items: Array<PericiaDTO>;
    total: number;
    
    constructor() {}
}